import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12 2a3 3 0 0 0-3 3l5.872 5.872A3 3 0 0 0 15 10V5a3 3 0 0 0-3-3m4.391 10.391 1.457 1.457A7 7 0 0 0 19 10a1 1 0 1 0-2 0 5 5 0 0 1-.609 2.391m4.369 6.369L5.24 3.24a1.06 1.06 0 0 0-1.49 1.51L9 10a3 3 0 0 0 3 3l1.702 1.702A5.002 5.002 0 0 1 7 10a1 1 0 1 0-2 0 7 7 0 0 0 6 6.928V20H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-3.072a7 7 0 0 0 2.217-.711l4.033 4.033a1.06 1.06 0 0 0 1.51-1.49"
    }
  )
);
var SvgMicOffFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MicOffFilled_default = SvgMicOffFilled;

export { MicOffFilled_default as default };
